import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  AbstractControl,
  ValidatorFn,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatDialog } from "@angular/material/dialog";
import { CommonService } from "@services/common.service";

@Component({
    selector: "app-detail",
    templateUrl: "./detail.component.html",
    styleUrls: ["./detail.component.scss"],
    standalone: false
})
export class DetailDialogComponent implements OnInit {
  public categories: any;

  public detailForm!: UntypedFormGroup;
  public canvasType: any;
  public actionButton = "update";
  public canvas_id?: any;
  constructor(
    private fb: UntypedFormBuilder,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<DetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    public dialog: MatDialog
  ) {
    if (data) {
      this.title = data.name;
      this.module_id = data.category_id;
      this.description = data.description;
      this.canvasType = data.canvasType;
      if (data.securityGroups) this.securityGroups = data.securityGroups;
      if (data.actionButton) this.actionButton = data.actionButton;
      if (data.canvas_id) this.canvas_id = data.canvas_id;
    }
  }

  title!: string;
  module_id!: string;
  description!: string;
  assignedGroups: string = "";
  securityGroups: any = [];
  showCategory: boolean = false;

  onNoClick(): void {
    this.dialogRef.close();
  }

  modifyDetails() {
    if (this.detailForm.invalid) {
      return;
    }
    this.dialogRef.close({
      module_id: this.detailForm.get("module_id")!.value,
      title: this.detailForm.get("title")!.value,
      description: this.detailForm.get("description")!.value,
      securityGroups: this.securityGroups,
    });
  }

  getCategories() {
    this.categories = JSON.parse(sessionStorage.getItem("userCategoryListing"));
    if (this.categories) {
      if (this.categories.length > 1) {
        this.showCategory = true;
      } else {
        this.detailForm.controls["module_id"].setValue(this.categories[0].id);
        this.showCategory = false;
      }
    }
  }

  ngOnInit(): void {
    this.detailForm = this.fb.group({
      module_id: new UntypedFormControl(this.module_id, [Validators.required]),
      title: new UntypedFormControl(this.title, [Validators.required, this.validateNoWhitespace()]),
      description: new UntypedFormControl(this.description, [Validators.required, this.validateNoWhitespace()]),
    });
    this.getCategories();
  }

  // Validator to check if the input contains only whitespace characters
  validateNoWhitespace(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value && control.value.trim().length === 0) {
        return { 'whitespace': true };
      }
      return null;
    };
  }
}
